/**
 * @Description: 历史报刊页面
 * @author zhaijiayu
 * @date 2021/9/14
*/
<template>
  <div class="newspaper-container">
    <!--  筛选功能栏-->
    <section class="action-bar">
      <el-select v-model="type" class="filter" @change="getNewspaper">
        <el-option
          v-for="item in newspaperTypeList"
          :label="item.name"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <el-date-picker
        class="filter"
        type="date"
        v-model="date"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable="false"
        @change="getNewspaper"
      />
    </section>
    <!--报纸列表-->
    <section class="list-container publicScroll">
      <el-card class="item" v-for="(item, index) in newspaperList" :key="index">
        <!--        <div slot="header" class="name">{{ item.paperName }}</div>-->
        <el-image
          class="newspaper-img"
          :src="item.img"
          @click="handlePreview(item.pdf)"
        />
      </el-card>
    </section>
    <!--报纸预览弹框-->
    <el-dialog
      :visible.sync="showPreview"
      top="20px"
      :center="true"
      width="80%"
    >
      <iframe :src="previewSrc" class="preview-area" />
    </el-dialog>
  </div>
</template>

<script>
import { getFormatDate } from "../../utils/tools";

export default {
  name: "newspaper",
  data: function () {
    return {
      date: new Date(),
      type: 1,
      newspaperTypeList: [
        {
          name: "河南日报",
          value: 1,
        },
        {
          name: "河南商报",
          value: 2,
        },
        {
          name: "大河报",
          value: 3,
        },
        {
          name: "新媒体",
          value: 4,
        },
        {
          name: "地市党报",
          value: 5,
        },
        {
          name: "河南日报农村版",
          value: 6,
        },
        {
          name: "大河健康报",
          value: 7,
        },
        {
          name: "法制报",
          value: 8,
        },
      ],
      newspaperList: [],
      previewSrc: "",
      showPreview: false,
    };
  },
  async mounted() {
    await this.getNewspaper();
  },
  methods: {
    /**
     * 获取报纸列表
     */
    getNewspaper: async function () {
      try {
        const { data } = await this.$axios(
          "https://rm.hnby.com.cn/bigscreen/hisPaper",
          {
            method: "get",
            params: {
              date: getFormatDate(this.date),
              type: this.type,
            },
          }
        );
        this.newspaperList = data ?? [];
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 展示预览
     * @param src 预览的pdf链接
     */
    handlePreview: function (src) {
      this.previewSrc = src;
      this.showPreview = true;
    },
  },
};
</script>

<style scoped lang="scss">
.newspaper-container {
  background: #fff;
  padding: 32px;
  border-radius: 8px;

  .action-bar {
    .filter {
      width: 150px;
      margin-right: 20px;
    }
  }
  .list-container {
    margin-top: 22px;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    height: calc(100vh - 275px);
    overflow: scroll;
    padding-right: 15px;

    .item:nth-child(4n + 1) {
      margin-left: 0;
    }
    .item {
      width: calc((100% - 60px) / 4);
      margin-left: 20px;
      margin-bottom: 20px;

      .newspaper-img {
        width: 100%;
      }

      /deep/.el-card__body {
        padding: 0;
      }
      .name {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
  .preview-area {
    height: calc(100vh - 120px);
    width: 100%;
  }
}
</style>